export type AppLayoutVariant =
  | 'align-left'
  | 'transparent-content'
  | 'full-bleed'
  | 'fit-content'
  | 'transparent-border';

export const AppLayoutHeaderSizes = {
  default: { logoHeight: '3.5rem', paddingBlock: 'sm' },
  discoveryShopping: { logoHeight: '3rem', paddingBlock: 'xs' },
} as const;

type HeaderSizes =
  (typeof AppLayoutHeaderSizes)[keyof typeof AppLayoutHeaderSizes];

const headerHeight = ({ logoHeight, paddingBlock }: HeaderSizes) =>
  `calc(${logoHeight} + 2 * var(--mantine-spacing-${paddingBlock}))`;

export const AppLayoutConstants = {
  HEADER_HEIGHT: headerHeight(AppLayoutHeaderSizes.default),
  HEADER_HEIGHT_DISCOVERY_SHOPPING: headerHeight(
    AppLayoutHeaderSizes.discoveryShopping
  ),
  IMPERSONATION_BAR_HEIGHT: '1.75rem',
  HEADER_ZINDEX: 100,
  MENU_OPEN_WIDTH: 312,
  MENU_CLOSE_WIDTH: 102,
} as const;

export const logout = () => {
  window.location.href = `${window.origin}/account/logout`;
};
